import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { BurgerButton } from "./BurgerButton";


export const Navabar = () => {
    const [open, setOpen] = React.useState(false);
    const location = useLocation();
    
    useEffect(() => {
      const primaryNav = document.querySelector(".primary-navigation");
      const body = document.querySelector("body");
      
      if (open) {
        primaryNav?.classList.add("animate", "pop", "opened");
        body?.setAttribute('data-overlay', 'true');
      } else {
        primaryNav?.classList.remove("animate", "pop", "opened");
        body?.removeAttribute('data-overlay');
      }
    }, [open]);

    // Close menu when route changes
    useEffect(() => {
      setOpen(false);
    }, [location]);
    
    return (
      <div className="container nav-wrapper">
        <NavLink to="/">
          <svg width={150} height={85} className="logo"></svg>
        </NavLink>
        <NavLink to="/book-appointment">
          <button className="button hide-mobile">Book an Appointment</button>
        </NavLink>
        <BurgerButton open={open} setOpen={setOpen} aria-expanded={open} />
        <nav className="primary-navigation" id="primary-navigation">
          <ul arial-label="Primary" className="nav-list no-bullets">
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/about">About Us</NavLink>
            </li>
            <a onClick={() => setOpen(false)} href="#services">
              <li>Dental Services</li>
            </a>
            <li>
              <NavLink to="/patient-resources">Patient Resources</NavLink>
            </li>
            <NavLink to="/contact-us">
              <li>Contact Us</li>
            </NavLink>
          </ul>
        </nav>
      </div>
    );
}